import React from 'react';

// Put this at the start and end of an inline component (around the children)
// to work around this Chromium bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
const InlineChromiumBugfix = () => (
  <span contentEditable={false} style={{ fontSize: 0, userSelect: 'none' }} />
);

export default InlineChromiumBugfix;
